import type { ISpacers, TCommon } from './models';

export const DEFAULT_THEME = 'white';
export const THEMES = [DEFAULT_THEME, 'blue'];
export const MEDIA_SIZES = {
    desktop: '(min-width: 415px) and (max-width: 1199px)',
    desktop4K: '(min-width: 1921px)',
    desktopHD: '(min-width: 1200px) and (max-width: 1920px)',
    mobile: '(max-width: 414px)',
};

export const DEFAULT_PROPS: Partial<TCommon> = {
    backgroundId: null,
    breadcrumbs: null,
    image: '',
    styles: {},
    subtitle: '',
    theme: DEFAULT_THEME,
    imageAltText: 'Картинка баннера',
    size: 's',
};

export const DESKTOP_SPACERS: ISpacers = {
    top: 'xs',
    bottom: '2xl',
    bottom2: '2xl',
};

export const MOBILE_SPACERS: ISpacers = {
    bottom: 'xs',
};
